module.exports = __webpack_public_path__ + "img/白及.bbe68405.jpg";